const company = function () {

    $(document).on('click', '.searchParentCompanyButton', function () {
        var url = '/popup_mutter_search.php?fid=' + $('#dataId').val();

        var p = new Esearcher.Popup(url, 'Muttersuche');
        p.show();
    });

    $(document).on('change', '.visitCountryInfo', function () {

        var link = $('.visitCountryInfoButton');

        var countryStr = $(this).find('option:selected').text()
                .replace(/ä/g, 'ae')
                .replace(/ö/g, 'oe')
                .replace(/ü/g, 'ue')
                .replace(/Ä/g, 'Ae')
                .replace(/Ö/g, 'Oe')
                .replace(/Ü/g, 'Ue')
                .replace(/ß/g, 'ss');

        var url = Esearcher.Template.parse(link.attr('data-url-template'), {
            country: countryStr
        });

        link.attr('href', url);
    });
};

export default company;